// Configuration de l'application
export const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://api.reportingserver.sigamix.com',
  apiUrlHttps: process.env.REACT_APP_API_URL_HTTPS || 'https://api.reportingserver.sigamix.com',
  
  // Configuration des endpoints
  endpoints: {
    auth: '/api/auth',
    tenants: '/api/tenants',
    users: '/api/users',
    reports: '/api/reportmanagement',
    reportsView: '/api/reportsview'
  },
  
  // Configuration de l'upload
  upload: {
    maxFileSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: ['.trdp']
  },
  
  // Configuration de l'authentification
  auth: {
    tokenKey: 'authToken',
    demoCredentials: {
      username: 'admin',
      password: 'admin'
    }
  }
};


